import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.get-prototype-of.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.starts-with.js";
import "core-js/modules/es.string.trim.js";
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
import { showToast } from 'vant';
import 'vant/es/toast/style';
import { AuthApi, AuthService } from '../../api/auth';
export default {
  name: 'Login',
  data: function data() {
    return {
      phone: '',
      code: '',
      sending: false,
      countdown: 60,
      timer: null
    };
  },
  computed: {
    sendText: function sendText() {
      return this.sending ? "\u91CD\u65B0\u53D1\u9001(".concat(this.countdown, "s)") : '发送验证码';
    }
  },
  methods: {
    onSubmit: function onSubmit() {
      var _this = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var res, token, _t;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              if (!(!_this.phone || !_this.code)) {
                _context.n = 1;
                break;
              }
              showToast('请输入手机号和验证码');
              return _context.a(2);
            case 1:
              _context.p = 1;
              _context.n = 2;
              return AuthApi.login(_this.formatPhoneForOtp(_this.phone), _this.code);
            case 2:
              res = _context.v;
              token = (res === null || res === void 0 ? void 0 : res.access_token) || (res === null || res === void 0 ? void 0 : res.token) || '';
              if (token) {
                AuthService.setAccessToken(token);
              }
              if (res !== null && res !== void 0 && res.refresh_token) {
                localStorage.setItem('refresh_token', res.refresh_token);
              }
              showToast('登录成功');
              _this.$router.push({
                name: 'publish'
              });
              _context.n = 4;
              break;
            case 3:
              _context.p = 3;
              _t = _context.v;
              showToast((_t === null || _t === void 0 ? void 0 : _t.message) || '登录失败');
            case 4:
              return _context.a(2);
          }
        }, _callee, null, [[1, 3]]);
      }))();
    },
    onSendCode: function onSendCode() {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var _t2;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              if (!_this2.sending) {
                _context2.n = 1;
                break;
              }
              return _context2.a(2);
            case 1:
              if (_this2.isValidPhone(_this2.phone)) {
                _context2.n = 2;
                break;
              }
              showToast('请输入有效的手机号');
              return _context2.a(2);
            case 2:
              _this2.sending = true;
              _this2.countdown = 60;
              _this2.startCountdown();
              _context2.p = 3;
              _context2.n = 4;
              return AuthApi.sendCode(_this2.formatPhoneForOtp(_this2.phone));
            case 4:
              showToast('验证码已发送');
              _context2.n = 6;
              break;
            case 5:
              _context2.p = 5;
              _t2 = _context2.v;
              showToast((_t2 === null || _t2 === void 0 ? void 0 : _t2.message) || '验证码发送失败');
              _this2.sending = false;
              _this2.countdown = 60;
              if (_this2.timer) {
                clearInterval(_this2.timer);
                _this2.timer = null;
              }
            case 6:
              return _context2.a(2);
          }
        }, _callee2, null, [[3, 5]]);
      }))();
    },
    isValidPhone: function isValidPhone(value) {
      var v = String(value || '').trim();
      return /^(\+?\d{6,15})$/.test(v) || /^1\d{10}$/.test(v) || /^190\d{8}$/.test(v);
    },
    formatPhoneForOtp: function formatPhoneForOtp(value) {
      if (!value) return value;
      if (value.startsWith('+')) return value;
      if (/^1\d{10}$/.test(value)) return "+86".concat(value);
      return value;
    },
    startCountdown: function startCountdown() {
      var _this3 = this;
      if (this.timer) {
        clearInterval(this.timer);
      }
      this.timer = setInterval(function () {
        if (_this3.countdown <= 1) {
          clearInterval(_this3.timer);
          _this3.timer = null;
          _this3.sending = false;
          _this3.countdown = 60;
        } else {
          _this3.countdown -= 1;
        }
      }, 1000);
    }
  },
  beforeUnmount: function beforeUnmount() {
    if (this.timer) {
      clearInterval(this.timer);
      this.timer = null;
    }
  }
};